import Vue from 'vue'
import VueRouter from 'vue-router'
import CustomerServices from '../views/page/customer_services.vue'
import PlaceHolderPage from '../views/page/page_holder_tab.vue'
import Diagnostics from '../views/content/diagnostics.vue'
import Inventory from '../views/content/inventory.vue'
import PlaceHolder from '../views/content/place_holder.vue'

Vue.use(VueRouter)

const routes = [
  {
    path: '/',
    name: 'customer_services',
    component: CustomerServices
  },
  {
    path: '/customer-services',
    name: 'customer_services',
    component: CustomerServices,
    children: [
      {
        path: '/customer-services/diagnostics',
        name: Diagnostics.route,
        component: Diagnostics
      },
      {
        path: '/customer-services/inventory',
        name: Inventory.route,
        component: Inventory
      },
      {
        path: '/customer-services/place-holder',
        name: PlaceHolder.route,
        component: PlaceHolder
      },
    ]
  },
  {
    path: '/place-holder-tab',
    name: 'place_holder_tab',
    component: PlaceHolderPage,
  },
  {
    path: '/help',
    name: 'help',
    // route level code-splitting
    // this generates a separate chunk (about.[hash].js) for this route
    // which is lazy-loaded when the route is visited.
    component: () => import(/* webpackChunkName: "about" */ '../views/page/help.vue')
  },
  {
    path: '/account',
    name: 'account',
    // route level code-splitting
    // this generates a separate chunk (about.[hash].js) for this route
    // which is lazy-loaded when the route is visited.
    component: () => import(/* webpackChunkName: "about" */ '../views/page/account.vue')
  }
]

const router = new VueRouter({
  mode: 'history',
  base: process.env.BASE_URL,
  routes
})
function hasQueryParams(route) {
  return !!Object.keys(route.query).length
}
router.beforeEach((to, from, next) => {
  if(to.name === Diagnostics.route && !hasQueryParams(to) && hasQueryParams(from)){
    next({name: to.name, query: from.query});
  } else {
    next()
  }
})
export default router
